module.exports = __webpack_public_path__ + "img/fish.71a2657.webp";